import {SettingsParamsType} from '../../types/createStylesParams'

import {textsSettingsParams, TextsSettingsParams} from './Settings/Tabs/Texts/settingsParams'
import {layoutSettingsParams, LayoutSettingsParams} from './Settings/Tabs/Layout/settingsParams'
import {DisplaySettingsParams, displaySettingsParams} from './Settings/Tabs/Display/settingsParams'

export type SettingsParams = TextsSettingsParams & LayoutSettingsParams & DisplaySettingsParams

export const settingsParams: SettingsParamsType<SettingsParams> = {
  ...textsSettingsParams,
  ...layoutSettingsParams,
  ...displaySettingsParams,
}

export default settingsParams
